const sanitizeBaseUrl = (value) => {
	if (typeof value !== 'string') {
		return '';
	}
	const trimmed = value.trim();
	if (!trimmed) {
		return '';
	}
	return trimmed.replace(/\/$/, '');
};

const DEFAULT_PROD_BASE_URL = 'https://moskva-kniga.ru';
const DEFAULT_DEV_BASE_URL = 'http://localhost:8081';
const IMAGE_BASE_URL = sanitizeBaseUrl(process.env.REACT_APP_IMAGE_BASE_URL || '');

const resolveBaseUrl = () => {
	const envBase = sanitizeBaseUrl(process.env.REACT_APP_API_BASE_URL);
	if (envBase) {
		return envBase;
	}

	if (typeof window !== 'undefined' && window.location) {
		const origin = sanitizeBaseUrl(window.location.origin);
		const host = window.location.hostname;
		const port = Number.parseInt(window.location.port || '', 10);

		const isLocalhost = host === 'localhost' || host === '127.0.0.1';
		if (isLocalhost && (port === 3000 || port === 3001)) {
			return DEFAULT_DEV_BASE_URL;
		}

		return origin || DEFAULT_PROD_BASE_URL;
	}

	return DEFAULT_PROD_BASE_URL;
};

const API_BASE_URL = resolveBaseUrl();

const ensureLeadingSlash = (path) => {
	if (typeof path !== 'string') {
		return '';
	}
	return path.startsWith('/') ? path : `/${path}`;
};

export const getApiBaseUrl = () => API_BASE_URL;

export const buildApiUrl = (path = '') => {
	const normalizedPath = ensureLeadingSlash(path);
	return `${API_BASE_URL}${normalizedPath}`;
};

export const buildImageUrl = (imagePath = '') => {
	if (!imagePath) {
		return '';
	}
	const trimmed = imagePath.trim();
	if (!trimmed) {
		return '';
	}
	if (/^https?:\/\//i.test(trimmed)) {
		return trimmed;
	}
	const sanitizedImagePath = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
	if (IMAGE_BASE_URL) {
		return `${IMAGE_BASE_URL}/${encodeURIComponent(sanitizedImagePath)}`;
	}
	return buildApiUrl(`/api/image/${encodeURIComponent(sanitizedImagePath)}`);
};

export const fetchJson = (path, options = {}) => {
	return fetch(buildApiUrl(path), options).then((response) => {
		if (!response.ok) {
			throw new Error(`Request failed with status ${response.status}`);
		}
		return response.json();
	});
};
